import React, { useState } from 'react'
import CalendarTab from './CalendarTab'
import { getImages } from '../Const'
import WeekCalender from './WeekCalender'
import Marquee from "react-fast-marquee";

const CalenderTabContent = ({announcements,leadData}) => {

   const [activeCalender, setActiveCalender] = useState('weekly');
   const [activeLocations, setActiveLocations] = useState(["BOYNTON BEACH","POMPANO BEACH"]);

   const filterLocation = (v) => { 
      console.log("v",v);
      let arr = activeLocations;
      if(arr && arr.includes(v)) {
         arr = arr.filter(a => a !== v);
      } else { 
         arr.push(v);
      }
      setActiveLocations([...arr]);
   }

   return (
      <>
         <div className='dark-theme pt-3'>
         {announcements && announcements.length > 0 && <div className='cl-scroll-box announcement-box mb-4'>
               <div className='honk-icon'>
                  <img alt='honk-icon' src={getImages('honk-icon.png')} />
               </div>
                  <div className="marquee-items">
                     <Marquee gradient={false} speed={80} pauseOnHover={false}>
                           {announcements.map((v,i) => (
                              <div className="marquee-scrolling-items" key={i}>
                                 <span className='hsi-circle'>{i+1}</span> {v.announcement}
                              </div>
                           ))}
                     </Marquee>
                  </div>
               <div className='view-all-box'>
                  {/* <button type='button' className='view-all-btn'>View All</button> */}
               </div>
            </div>}
         </div>

         <div className="calendar-block cal-calendar-block">
            <div className='d-lg-none'>
               <button className='mob-back-btn' type='button'><span><img src={getImages('left-arrow.svg')} /></span> Back</button>
            </div>
            <div className='d-flex align-items-center justify-content-between'>
               <div className="d-flex align-items-center justify-content-between">
                  <div className='main-heading text-uppercase'>Appointment Calendar</div>
                  <div className="d-lg-none text-end">
                     <button type="button" className="blue-transparent-btn text-uppercase filter-btn"><img src={getImages('filter-icon.svg')} /> Filters</button>
                  </div>
               </div>
               <div className={`d-inline-flex align-items-center list_filter`}>
                  <div className='d-flex align-items-center filter-col'>
                     <label>View</label>
                     <select defaultValue={activeCalender} onChange={(e) => setActiveCalender(e.target.value)} className="form-control">
                        <option value="monthly">Monthly</option>
                        <option value="weekly">Weekly</option>
                     </select>
                  </div>
                  <div className="d-flex align-items-center filter-col ms-4">
                     <label onClick={(e)=>filterLocation("BOYNTON BEACH")} className={` ${activeLocations.includes("BOYNTON BEACH") ? 'active' : ''} custom-checkbox   cc-gray-btn`}>
                        <label htmlFor="Boynton">Boynton</label>
                     </label>
                  </div>
                  <div className="d-flex align-items-center filter-col ms-4">
                     <label onClick={(e)=>filterLocation("POMPANO BEACH")} className={` ${activeLocations.includes("POMPANO BEACH") ? 'active' : ''} custom-checkbox   cc-gray-btn`}>
                        <label htmlFor="PompanoBeach">Pompano Beach</label>
                     </label>
                  </div>
               </div>
            </div>
            {activeCalender  === 'weekly' ?
               <WeekCalender leadData={leadData.filter((lead) => lead.appointment_date && !lead.no_show)} activeLocations={activeLocations} /> 
               : 
               <CalendarTab activeLocations={activeLocations} leadData={leadData.filter((lead) => lead.appointment_date)} />
            }
         </div>
      </>
   )
}

export default CalenderTabContent